var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      fill: "#e0e0e0",
      right: 15
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.714 15.086c-0.247-0.355-6.151-8.686-15.714-8.686s-15.467 8.332-15.714 8.686c-0.179 0.255-0.286 0.572-0.286 0.914s0.107 0.659 0.29 0.919l-0.003-0.005c0.247 0.355 6.151 8.686 15.714 8.686s15.467-8.332 15.714-8.686c0.179-0.255 0.286-0.572 0.286-0.914s-0.107-0.659-0.29-0.919l0.003 0.005zM16 24c-8.836 0-14.4-8-14.4-8s5.564-8 14.4-8 14.4 8 14.4 8-5.564 8-14.4 8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.6c-3.534 0-6.4 2.865-6.4 6.4s2.865 6.4 6.4 6.4c3.535 0 6.4-2.865 6.4-6.4s-2.866-6.4-6.4-6.4zM16 20.8c-2.647 0-4.8-2.153-4.8-4.8s2.153-4.8 4.8-4.8 4.8 2.153 4.8 4.8-2.153 4.8-4.8 4.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.6a61e61d0f36f8e792b998cc4904b332.svg";
export { ForwardRef as ReactComponent };